import React from "react";
import { useLanguage } from "../LangTranslation/LanguageContext";

import "./ShortcutButton.css";
import { primaryColor } from "../../utilities/colors";
const ShortcutButton = ({
  dataId,
  name,
  show,
  msg,
  showSub,
  msgSub,
  onClick,
}) => {

  const { language, translations } = useLanguage();
  const t = translations[language];
  return (
    <div
      className="tile block col-md-3 col-sm-6 col-xs-12 bootCols"
      data-id={dataId}
      onClick={onClick}
    >
      <div
        className="tile-container  d-flex justify-content-around align-items-center position-relative w-100 my-3"
        style={{
          backgroundColor: "#FFFFFF",
          height: "82px",
          boxShadow: "0px 23px 44px 0px rgba(176, 183, 195, 0.14)",
        }}
      >
        <div
          style={{ backgroundColor: "#FFFFFF" }}
          className="tile-container__icon-container d-flex justify-content-center align-items-center"
        >
          <i style={{ color: "#B45021" }} className="fa fa-th fa-sm"></i>
        </div>
        <div className="wrapper d-flex flex-column" style={{ width: "100%" }}>
          <div
            className="tile-container__status-container d-flex align-items-center"
            title={name}
            style={{ cursor: "pointer", width: "100%", padding: "0px 10px" }}
          >
            <h6
              className="status-container__title my-3"
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontWeight: "600",
                width: "inherit",
              }}
            >
              {name}
            </h6>
            <i
              className={`${
                dataId == 102 && show
                  ? "exclaim_company fa fa-exclamation-triangle"
                  : dataId == 101 && showSub
                  ? "exclaim_subscription fa fa-exclamation-triangle"
                  : ""
              } fa-lg mx-3 text-warning `}
              title={name}
            ></i>
            <i
              className="fa fa-chevron-circle-right cursor-pointer fa-lg"
              style={{
                color: primaryColor.primary,
              }}
            ></i>
          </div>
          {show && dataId === 102 ? (
            <sub
              className={`msg small`}
              style={{ color: primaryColor.primary, padding: "0px 10px" }}
              title={msg}
            >
              {t["missing information"]}
            </sub>
          ) : showSub && dataId === 101 ? (
            <sub
              className={`msg small`}
              style={{ color: primaryColor.primary, padding: "0px 10px" }}
            >
              {msgSub}
            </sub>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ShortcutButton;
